import React from 'react';

import Modal from 'components/commons/modal/Modal';
import Button from 'components/commons/button/Button';

type GroupingTutorialModalProps = {
  isShow: boolean;
  close: () => void;
};

const GroupingTutorialModal: React.FC<GroupingTutorialModalProps> = props => {
  const title = (
    <>
      新しく作成したグループに
      <br />
      口座を移動させてみましょう
    </>
  );

  const content = (
    <>
      資産のグループ分けは口座情報の右側の「
      <i className="icon-more-vertical"></i>
      」から操作することができます。
    </>
  );
  return (
    <Modal isShow={props.isShow} close={props.close}>
      <div className="ui-effect-fade-in-300 modal-advice">
        <div className="flex pt-3 px-3 justify-end modal-header">
          <div className="flex-grow flex justify-center items-center">
            <div className="modal-header-title">{title}</div>
          </div>
          <button>
            <i
              className="icon-close text-2xl text-gray-500 text-center cursor-pointer"
              onClick={props.close}></i>
          </button>
        </div>
        <div className="modal-advice-body">
          <div className="modal-primary-note" style={{ marginBottom: '8px' }}>
            {content}
          </div>
          <img
            src="/static/images/advisor/modal_img_group.svg"
            alt=""
            style={{ marginBottom: '8px' }}
          />
          <div className="btn-vertical-col">
            <Button fluid text onClick={props.close}>
              閉じる
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GroupingTutorialModal;
